module.exports = __webpack_public_path__ + "static/media/FZLTXHB--B51-0.ce89155c.svg";